export const PRIMARY = 'primary';
export const DELETE = 'delete';
